import styled from '@emotion/styled';

export const MainBlock = styled.div`
  border: 4px solid #6262621a;
  border-radius: 30px;
  padding: 40px;

  /* Если родитель — flex, предотвращаем вертикальное растягивание */
  align-self: flex-start;

  /* Картинка управляет высотой блока */
  & > img {
    display: block;
    max-width: 100%;
    height: auto;
  }
`;
